export const classes = {
  firstSlider: 'first-slider',
  lastSlider: 'last-slider',
  swiperWrapper: 'swiper-wrapper',
  swiperBanner: 'swiper-banner',
  swiperBannerContent: 'swiper-banner-content',
  bannerItem: 'banner-item',
  swiperPagination: 'swiper-pagination',
  swiperButtonNext: 'swiper-button-next',
  swiperButtonPrev: 'swiper-button-prev',
  wrapSwiperButtonRight: 'wrap-swiper-button-right',
  wrapSwiperButtonLeft: 'wrap-swiper-button-left',
  wrapSwiperButton: 'wrap-swiper-button',
  swiperNoSwiping: 'swiper-no-swiping',
  btnPlayPause: 'btn-play-pause',
  btnControlSound: 'btn-control-sound',
  bgVideo: 'bg-video',
  pauseVideo: 'pause-video',
  pause: 'pause',
  textControl: 'text-control',
  openVideo: 'open-video',
  hidden: 'hidden',
  hoverNext: 'hoverNext',
  hoverPrev: 'hoverPrev',
  controlVideo: 'control-video',
  activeSound: 'active-sound',
  bannerBgVideo: 'banner-bg-video',
  focusNext: 'focus-next',
  focusPrev: 'focus-prev',
  eventPointer: 'events-none',
  kwkWidget: 'kWidgetIframeContainer',
  cloneItem: 'clone-item',
};

export const config = {
  undefined: 'undefined',
  handleFunction: 'function',
  dataPlayer: 'data-player',
  isPlayer: 'player',
  desktop: 1200,
  // isPlayer: 'player';
  index: 1,
  // window.listVideo = [],
  checkCallSetup: false,
};
